/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */

import * as React from 'react'
import DashboardIcon from '@mui/icons-material/Dashboard'

import {ToggleFunctionType} from "../layouts/Layout"
import MenuDrawer from "./MenuDrawer"

interface NavigatorProps {
  open: boolean
  toggleDrawer: ToggleFunctionType
}

const NavigatorDrawer: React.FC<NavigatorProps> = ({open, toggleDrawer}) => {
  return (
    <MenuDrawer
      anchor="left"
      open={open}
      toggleDrawer={toggleDrawer}
      closeOnMenuItemClick={true}
      items={[
        {text: 'Home', icon: <DashboardIcon/>, divider: false},
        {text: 'About', icon: <DashboardIcon/>, divider: false},
      ]}
    />
  )
}

export default NavigatorDrawer
